import styled from 'styled-components';

const FilterFieldset = styled.fieldset`
  margin: 0;
  padding: 0;
  border: none;
`;

export default FilterFieldset;
